import Client from "../client/ClientTV"
const resource = "/api/v2"

const getListForHome = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/events/`, { params })
}
const getFullByBlock = (cookies, eventId, params) => {
  return Client(cookies).get(`${resource}/publish/see-more/events/${eventId}/`, {
    params
  })
}
const getBanner = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/banner/`, { params })
}
const getEventOrVideo = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/event/`, { params })
}
const search = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/events/elastic-search/`, { params })
}
const getRelatedTo = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/event/related-to/`, { params })
}
const getSlides = (cookies) => {
  return Client(cookies).get(`${resource}/publish/slides/`)
}

const getLeagues = (cookies) => {
  return Client(cookies).get(`${resource}/publish/home/leagues/`)
}
const getSeemoreLeagues = (cookies) => {
  return Client(cookies).get(`${resource}/publish/leagues/`)
}
const getDetailCategory = (cookies, id, params) => {
  return Client(cookies).get(`${resource}/publish/get-all-data/leagues/${id}`, { params })
}
const getFullCategoryChild = (cookies, eventId, params) => {
  return Client(cookies).get(`${resource}/publish/category/see-more/${eventId}`, { params })
}

const getDetailTopic = (cookies, id, params) => {
  return Client(cookies).get(`${resource}/publish/topic/${id}/`, { params })
}

const getFullTopicChild = (cookies, eventId, params) => {
  return Client(cookies).get(`${resource}/publish/topic/see-more/${eventId}/`, { params })
}
const getVideoOfLeague = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/league-detail/`, { params })
}

const getFullLeagueChild = (cookies, params) => {
  return Client(cookies).get(`${resource}/publish/video/`, { params })
}

const getDetailLeague = (cookies, id, params) => {
  return Client(cookies).get(`${resource}/publish/league/${id}/`, { params })
}

const getRecommends = (cookies, id, params) => {
  return Client(cookies).get(`${resource}/publish/recommendationBlock`, { params })
}

const getDetailRecommend = (cookies, block_id) => {
  return Client(cookies).get(`${resource}/publish/recommendationBlock/get-detail`, {
    params: { block_id }
  })
}

const getDetailSubject = (cookies, id, params) => {
  return Client(cookies).get(`${resource}/publish/topic/get-event-topic/${id}`, {
    params
  })
}

const userRepository = {
  getEventOrVideo,
  getFullByBlock,
  getListForHome,
  search,
  getBanner,
  getRelatedTo,
  getSlides,
  getLeagues,
  getSeemoreLeagues,
  getDetailCategory,
  getFullCategoryChild,
  getDetailTopic,
  getFullTopicChild,
  getVideoOfLeague,
  getFullLeagueChild,
  getDetailLeague,
  getRecommends,
  getDetailRecommend,
  getDetailSubject
}

export default userRepository
